export const environment = {
  envName: 'qa',
  production: false,
  authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/v2.0',
  clientId: '39a2c485-8d51-45e7-be7e-52c200206157',
  redirectUri: `${location.protocol}//${location.hostname}${location.port && ':' + location.port}/`,
  audience: 'https://iopoc-test.azure.chevron.com',
  knownAuthorities: ['https://login.microsoftonline.com', 'https://sts.windows.net'],
  apiUrl: 'https://iopoc-api-qa.azure.chevron.com/api',
  engineApiUrl: 'https://workflow-api-qa-cvx.ashypond-6972faf6.westeurope.azurecontainerapps.io',
  engineScope: 'https://workflow-engine-dev.azure.chevron.com/user_impersonation',
  appInsightsConnectionString: '__APPINSIGHTS_CONNECTION_STRING__',
  appInsightsCorrelateEngine: false,
  useMockData: false,
  agentRunRerunsEnabled: true,
};
